const ChemicalStructureSearch = () =>
  import("../components/chemtracker/ChemicalStructureSearch.vue");

const routes = [
  {
    path: "/node/:groupNid/chemtracker/structure-search",
    component: ChemicalStructureSearch,
    props: true,
  },
  {
    path: "/raft/chemtracker/structure-search",
    component: ChemicalStructureSearch,
  },
];

export default routes;
